import React, { useState, useEffect } from "react";

const IngredientPopup = ({
  open,
  product,
  ingredients = [],
  onClose,
  onConfirm,
}) => {
  const [selectedIngredients, setSelectedIngredients] = useState([]);

  useEffect(() => {
    if (open) setSelectedIngredients([]); // reset when opened
  }, [open]);

  const handleCheckboxChange = (event, ingredient) => {
    if (event.target.checked) {
      setSelectedIngredients((prev) => [...prev, ingredient]);
    } else {
      setSelectedIngredients((prev) =>
        prev.filter((i) => i._id !== ingredient._id)
      );
    }
  };

  if (!open) return null;

  return (
    <div
      className="modal fade show d-block"
      style={{ background: "rgba(0,0,0,0.5)" }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title" onClick={() => console.log(selectedIngredients)}>{product?.titre?.fr}</h5>
            <button
              className="btn btn-primary p-0"
              onClick={onClose}
              style={{
                backgroundColor: "red",
                width: "24px",
                height: "24px",
              }}
            >
              <i className="fas fa-times"></i>{" "}
            </button>
          </div>

          <div className="modal-body">
            <div className="supplements-grid">
              {ingredients.map((value, index) => (
                <label key={value._id || index} className="supplement-card">
                  <input
                    type="checkbox"
                    className="hidden-checkbox"
                    onChange={(event) => handleCheckboxChange(event, value)}
                  />
                  <div className="card-content">
                    <span className="check-indicator"></span>
                    <span className="ing-name">{value.titre}</span>
                    {value.prix > 0 && (
                      <span className="ing-price">+{value.prix.toFixed(2)} TND</span>
                    )}
                  </div>
                </label>
              ))}
            </div>
          </div>

          <div className="modal-footer">
            <button className="btn btn-secondary" onClick={onClose}>
              Annuler
            </button>
            <button
              className="btn btn-primary"
              onClick={() => onConfirm(selectedIngredients)}
            >
              Ajouter
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

export default IngredientPopup;
